import React from 'react';
import { SafeStorage } from '../utils/webview';

const _ = ({action, subject, children}) => {
    const [rules, setRules] = React.useState([]);
    
    React.useEffect(() => {
        const fetchRules = async () => {
            try {
                let rulesData = await SafeStorage.getItem('user-ability', true);
                rulesData = rulesData ? JSON.parse(rulesData) : [];
                setRules(rulesData);
            } catch (e) {
                console.error('Failed to parse user ability rules:', e);
                setRules([]);
            }
        };
        
        fetchRules();
    }, []);

    const can = rules.find(rule => {
        if(rule.action === 'manage' && rule.subject === 'all') return true;
        return rule.action === action && rule.subject === subject;
    });

    return (
        <>
            {can ? children : null}
        </>
    );
};

export default _;